/**
 * Snapshot regenerator utility for storing and restoring brand state
 */
export interface BrandSnapshot {
  brandId?: string;
  groupId?: string;
}

export class BrandSnapshotRegenerator {
  /**
   * Store snapshot in location state
   */
  static storeSnapshot(
    snapshot: BrandSnapshot,
    currentPathname: string,
    navigate: (
      path: string,
      options?: { replace?: boolean; state?: unknown }
    ) => void
  ) {
    navigate(currentPathname, {
      replace: true,
      state: snapshot,
    });
  }

  /**
   * Restore snapshot from location state
   * Can also handle GroupSnapshot (from GroupRouter) which only has groupId
   */
  static restoreSnapshot(locationState: unknown): BrandSnapshot | null {
    if (locationState && typeof locationState === "object") {
      const state = locationState as Record<string, unknown>;
      return {
        brandId: typeof state.brandId === "string" ? state.brandId : undefined,
        groupId: typeof state.groupId === "string" ? state.groupId : undefined,
      };
    }
    return null;
  }
}
